export default __webpack_public_path__ + "static/media/LeagueGothic-Regular.308bc269.otf";